<div class="container sidebar2">
  <h2 style="text-align: center;" class="animated  bounceInLeft delay-2s">Stats over the world</h2>
  <div class="row" style="padding-top: 50px;margin: 8px;">
    <div class="col-md-4 animated  fadeInDown delay-2s">
      <h3>Infected</h3>
      <h1 >{{  caseees[0].cases  |  number: "1.0"  }}</h1>
    </div>
    <div class="col-md-4 animated  fadeInDown delay-3s" >
      <h3>Recovery</h3>
      <h1 style="color: green;">{{  caseees[0].recovered  |  number: "1.0"  }}</h1>
    </div>
    <div class="col-md-4 animated  fadeInDown delay-4s">
      <h3>Deaths</h3>
      <h1 style="color: red;">{{  caseees[0].deaths  |  number: "1.0"  }}</h1>
    </div>
  </div>
</div>
